import http from './http';
import config from '~/config';

export const getSection = (titleOpinionId, sectionTypeId) => {
    return http.get2(`${config.urls.base}/section`, { sectionTypeId, titleOpinionId });
};

export const createSection = ({ sectionTypeId, path, value, titleOpinionId = null}) => {
    const payload = {
        sectionTypeId,
        path,
        value
    };

    if (titleOpinionId !== null)
        payload.titleOpinionId = titleOpinionId;

    return http.post(`${config.urls.base}/section`, payload);
};

export const updateSection = ({ id, path, value }) => {
    const payload = { path, value };
    return http.put(`${config.urls.base}/section/${id}`, payload);
};

export const getSectionDetail = (titleOpinionId, sectionTypeId) => {
    return http.get2(`${config.urls.base}/sectionDetail`, { sectionTypeId, titleOpinionId });
};

export const saveSectionDetail = (data, sectionDetailId = 0) => {
    const sectionId = data.sectionId;
    let url = `${config.urls.base}/section/${sectionId}/details`;
    if (sectionDetailId > 0) {
        url += `?sectionDetailId=${sectionDetailId}`;
    }

    return http.put(url, data);
};

export const addSectionDetailDocument = async (sectionDetailId, document) => {
    const upload = {
        name: document.fileName,
        fileSize: document.fileSize,
        typeId: document.typeId,
        uuid: document.cloudFileName,
        path: document.cloudStoragePath,
        extension: document.fileExtension
    };

    const uri = `${config.urls.base}/sectionDetail/${sectionDetailId}/attachments`;

    const response = await http.put(uri, upload);

    if (response.errored)
        throw new Error(`Failed to add sectionDetailAttachment ${upload.uuid} - ${response.error}`);
    
    return response;    
};

export const addSectionDocument = async (sectionId, document) => {
    const upload = {
        name: document.fileName,
        fileSize: document.fileSize,
        typeId: document.typeId,
        uuid: document.cloudFileName,
        path: document.cloudStoragePath,
        extension: document.fileExtension
    };

    const uri = `${config.urls.base}/section/${sectionId}/attachments`;

    const response = await http.put(uri, upload);

    if (response.errored)
        throw new Error(`Failed to add sectionAttachment ${upload.uuid} - ${response.error}`);
    
    return response;  
};

export const deleteSectionDocument = async (sectionId, attachmentId) => {
    const uri = `${config.urls.base}/section/${sectionId}/attachments/${attachmentId}`;

    const response = await http.del(uri);

    if (response.errored)
        throw new Error(`Failed to remove sectionAttachment ${attachmentId} - ${response.error}`);
    
    return response;   
};

export const deleteSectionDetailDocument = async (sectionDetailId, attachmentId) => {
    const uri = `${config.urls.base}/sectionDetail/${sectionDetailId}/attachments/${attachmentId}`;

    const response = await http.del(uri);

    if (response.errored)
        throw new Error(`Failed to remove sectionDetailAttachment ${attachmentId} - ${response.error}`);
    
    return response;      
};

export const deleteSectionDetail = (sectionDetailId) => {
    return http.del(`${config.urls.base}/sectionDetail/${sectionDetailId}`);
};

export const getSectionTypes = (category = null) => {
    const params = category ? { category } : {};

    return http.get2(`${config.urls.base}/sectionType`, params);
};

export default {
    getSectionTypes,
    getSection,
    createSection,
    updateSection,
    getSectionDetail,
    saveSectionDetail,
    deleteSectionDetail,
    addSectionDetailDocument,
    deleteSectionDetailDocument,
    addSectionDocument,
    deleteSectionDocument
};